module.exports = __webpack_public_path__ + "static/media/iot.7e5e0249.png";